/** @format */

import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'homefield-color-swatch',
  templateUrl: './color-swatch.component.html',
  styleUrl: './color-swatch.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldColorSwatchComponent implements OnInit {
  @HostBinding('style.--colorSwatchRadius')
  @Input()
  altText = '';

  @Input() color: string;
  @Input() colorSwatchHoverDimension = false;
  @Input() disabled: boolean;
  @Input() filterColorSwatchHoverDimension = false;
  @Input() height: string;
  @Input() imageSrc: string;
  isLazy = input(true);
  @Input() isPersonalization: boolean;
  @Input() radius = '';
  @Input() selected: boolean;
  @Input() tabIndex: number | string = '0';
  @Input() width: string;
  @Output() colorSwatchError = new EventEmitter();

  swatchAriaLabel = '';

  ngOnInit(): void {
    this.swatchAriaLabel = this.color ? `Color Option: ${this.color}` : '';
  }

  // Emitting image source to product swatch component.
  // Product swatch will have additional info
  // which will be suitable for the rumrunner custom event
  emitImageError(event): void {
    event.target.src =
      'https://images.dickssportinggoods.com/assets/icons/dsg/ImageUnavailablePDPSwatch.svg';
    this.colorSwatchError.emit(this.imageSrc);
  }

  attributeValueClicked(elem): void {
    elem.blur();
  }
}
